import styled from 'styled-components';

export const StyledOverviewSimple = styled.section`
    padding: 200px 0;
    .header{
        padding-top: 40px;
        position: relative;
        margin-bottom: 40px;
        &:after{
            position: absolute;
            width: 100%;
            background: #15263780;
            height: 1px;
            left: 0;
            right: 0;
            top: 0;
            content: '';
        }
        p{
            color: #15263780;
        }
    }
    .title{
        color: #152637;
        i{
            color: #DD223F;
        }
    }
    p{
        font-weight: 400;
        font-size: 1rem;        /* 16px */
        line-height: 1.5rem;    /* 24px */
        letter-spacing: 0;      /* 0% */
    }
    @media(max-width: 767px){
        .margin-top-60{
            margin-top: 60px;
        }
    }

    &.version{
        background: #EFEFEF;
        .title{
            i{
                color: #152637;
            }
        }
    }

    ul{
        margin-top: 40px;
        li{
            border-bottom: 1px solid #152637;
            padding-bottom: 10px;
            margin-bottom: 10px;
            color: #152637;
            font-weight: 400;
            font-size: 1rem;        /* 16px */
            line-height: 1.5rem;    /* 24px */
            letter-spacing: 0em;    /* 0% */
            position: relative;
            counter-increment: count;
            padding-left: 32px;

            &:before {
                width: 20px;
                height: 20px;
                background: #DD223F;
                content: counter(count, decimal);
                font-weight: 400;
                font-size: 1rem;        /* 16px ÷ 16 */
                line-height: 1.5rem;    /* 24px ÷ 16 */
                letter-spacing: 0;
                position: absolute;
                color: white;
                left: 0;
                top: 5px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
`;
